/// This file was generated DO NOT MODIFY
/// Source: PopEntityState.cs
/// Tool: http://frhagn.github.io/Typewriter/pages/documentation.html

export enum PopEntityStateEnum {
  Unchanged = 'Unchanged', //0
  Modified = 'Modified', //1
  
}
